import axios from 'axios';

export async function search(filters: Record<string, unknown>): Promise<App.Auth.Data.UserData[]> {
  return axios.get(route('api.users.search', filters)).then((res) => res.data);
}
